import { defineType } from 'sanity';

export const timelineSection = defineType({
    name: 'timelineSection',
    title: 'Timeline section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'events',
            title: 'Timeline Events',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'date',
                            title: 'Date',
                            type: 'localizedString',
                        },
                        {
                            name: 'title',
                            title: 'Title',
                            type: 'localizedString',
                        },
                        {
                            name: 'description',
                            title: 'Description',
                            type: 'localizedString',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Timeline Section: ${title['en'] || title['sr']}`,
            };
        },
    },
});
